// extracted by mini-css-extract-plugin
export default {"root":"Empty__root___cRsIZ","dark":"Empty__dark___PBJL1","content":"Empty__content___vCoDA","iconOnly":"Empty__iconOnly___oD9DZ"};